import axios from 'axios';

const membershipTierService = {
  getTiers: () => axios.get('/api/membership_tiers'),
};

export default membershipTierService;
